import {Injectable} from '@angular/core';
import {
  ContractDuration,
  DcpExtendedMetric,
  DcpMetric, JsonService, ProductQuantity,
  RenewalType, TypeValuePair, UsageType
} from '@dcp/configurator';
import {DcpMedia} from '../../model/dcp-media';

const BLOCKS_OF: string = 'blocksOf';
const SALES_METRIC: string = 'salesMetric';
const CONTRACT_DURATIONS: string = 'contractDurations';
const RENEWAL_TYPES: string = 'renewalTypes';
const USAGE_TYPES: string = 'usageTypes';
const PRODUCT_QUANTITY: string = 'productQuantity';
const PRODUCT_MEDIA: string = 'media';

@Injectable({
  providedIn: 'root'
})
export class DcpProductDataService extends JsonService {

  constructor() {
    super();
  }

  public getBlocksOf(data: TypeValuePair[]): DcpExtendedMetric {
    return this.getJsonDataValue(data, BLOCKS_OF);
  }

  public getSalesMetric(data: TypeValuePair[]): DcpMetric {
    return this.getJsonDataValue(data, SALES_METRIC);
  }

  public getContractDurations(data: TypeValuePair[]): ContractDuration[] {
    return this.getJsonDataValue(data, CONTRACT_DURATIONS);
  }

  public getRenewalTypes(data: TypeValuePair[]): RenewalType[] {
    return this.getJsonDataValue(data, RENEWAL_TYPES);
  }

  public getUsageTypes(data: TypeValuePair[]): UsageType[] {
    return this.getJsonDataValue(data, USAGE_TYPES);
  }

  public getProductQuantity(data: TypeValuePair[]): ProductQuantity {
    return this.getJsonDataValue(data, PRODUCT_QUANTITY);
  }

  public getMedia(data: TypeValuePair[]): DcpMedia[] {
    return this.getJsonDataValue(data, PRODUCT_MEDIA) || [];
  }
}
